import { z } from 'zod';
export const contact = z.object({
    id: z.number().int().positive(),
    customerId: z.number().int().positive(),
    salutation: z.string().nullable().optional(),
    firstName: z.string(),
    lastName: z.string(),
    fullName: z.string(),
    role: z.string().nullable().optional(),
    department: z.string().nullable().optional(),
    email: z.string().email().nullable().optional(),
    phone: z.string().nullable().optional(),
    mobile: z.string().nullable().optional(),
    notes: z.string().nullable().optional(),
    isPrimary: z.boolean(),
    archived: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createContactRequest = z
    .object({
    customerId: z.number().int().positive(),
    salutation: z.string().max(20).optional(),
    firstName: z.string().min(1).max(80),
    lastName: z.string().min(1).max(80),
    role: z.string().max(120).optional(),
    department: z.string().max(120).optional(),
    email: z.string().email().optional().or(z.literal('')),
    phone: z.string().max(40).optional(),
    mobile: z.string().max(40).optional(),
    notes: z.string().max(2000).optional(),
    isPrimary: z.boolean().optional(),
})
    .strict();
export const updateContactRequest = createContactRequest.partial().strict();
export const projectContactRoleEnum = z.enum([
    'Bauherr',
    'Auftraggeber',
    'Externer Prüfer',
    'Architekt',
    'Statiker',
    'Behörde',
    'Sonstiges',
]);
export const projectContact = z.object({
    id: z.number().int().positive(),
    projectId: z.number().int().positive(),
    contactId: z.number().int().positive(),
    contact: contact.optional(),
    roleInProject: z.string(),
    isPrimary: z.boolean(),
    notes: z.string().nullable().optional(),
    addedById: z.number().int().positive(),
    createdAt: z.string().datetime(),
});
export const addProjectContactRequest = z
    .object({
    contactId: z.number().int().positive(),
    roleInProject: z.string().min(1).max(80),
    isPrimary: z.boolean().optional(),
    notes: z.string().max(2000).optional(),
})
    .strict();
